<template lang="pug">
  b-container.content-wrap(fluid)
    b-row
      b-col.page-wrap(cols="12")
        div.mb-3(v-if="AppState.isMobile")
          b-breadcrumb(:items="tree")
        div.page-header(slot="header")
          b-container.d-flex.align-items-center(:class="{'justify-content-between': !AppState.isMobile, 'justify-content-end': AppState.isMobile}" fluid, v-if="!AppState.isStandalone")
            div.d-flex(v-if="!AppState.isMobile")
              b-breadcrumb(:items="tree")
              //b-breadcrumb(:items="tree")
              //span {{currentGroup}}
            div
              //b-button-group(size="sm")
                //b-button(@click="viewMode = 'list'", :variant="viewMode === 'list' ? 'secondary':'secondary'")
                b-button(@click="viewMode = 'list'", variant="secondary", :class= "{active: this.viewMode === 'list'}")
                  icon(name="list")
                  span.ml-2 리스트뷰
                //b-button.ml-2(@click="viewMode = 'icon'", :variant="viewMode === 'icon' ? 'secondary':'secondary'")
                b-button.ml-2(@click="viewMode = 'icon'", variant="secondary", :class= "{active: this.viewMode === 'icon'}")
                  icon(name="th-large")
                  span.ml-2 아이콘뷰
              b-button-group.excel-btn-group(v-if="excelAdd")
                div.mr-2
                  b-form-file(size="sm", @change="readFile")
                b-button.mr-2(
                  size="sm",
                  @click="onSubmit"
                ) {{$t('enrollment')}}
                b-button.mr-4(
                  v-if="lang === 'en'",
                  size="sm",
                  type="button",
                  variant="info",
                  :href="`${Form}/linkmemine_group_form_en.xlsx`", download
                ) {{$t('excel-form')}}
                b-button.mr-4(
                  v-else,
                  size="sm",
                  type="button",
                  variant="info",
                  :href="`${Form}/linkmemine_group_form_ko.xlsx`", download
                ) {{$t('excel-form')}}
                b-button.mr-2(
                  size="sm",
                  type="button",
                  variant="danger",
                  @click="excelCancel"
                ) {{$t('cancel')}}
              b-button-group.excel-btn-group(v-else)
                b-button.mr-2(v-if="this.tree.length !== 1" variant="secondary" size="sm" type="button" @click="onClickBack" ) {{$t('back')}}
                b-button.mr-2(
                  size="sm",
                  type="button",
                  variant="secondary",
                  @click="addGroup") {{$t('add_group')}}
                b-button.mr-2(
                  v-if="!AppState.env.VUE_APP_SCI",
                  size="sm",
                  type="button",
                  variant="secondary",
                  @click="excelAddGroups") {{$t('excel-groups')}}
                b-btn.delete-btn(variant="danger" size="sm", @click="checkedRemoteGroup") {{$t('delete')}}
      div
        b-button.tutorial-link(variant="link", size="sm", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_10.php")
          //icon(name="bookmark", style="margin:0 4px 0 2px; color: #0073BB")
          span {{$t('tutorial-group')}}
    
    
    b-card.table-card
      b-table(
        v-if="viewMode === 'list'"
        ref="groupTable"
        :fields="fields"
        :items="groupOnPage"
        :empty-text="$t('no-content')"
        show-empty
        responsive
      )
        template(v-slot:head(check)="row")
          b-form-checkbox(v-model="allSelected" @change="selectAllRows" :indeterminate="isIndeterminate")
        template(v-slot:cell(detail)="row")
          //@row-clicked="onRowClicked"
          router-link(:to="{name: 'group-detail', params: {groupPk: row.item.pk}}")
            //icon(name="cog", scale="1.1")
            img(src="../../assets/group_detail_icon.svg", scale="1.1")
        template(v-slot:cell(check)="row")
          b-form-checkbox(v-model="row.item._isSelected", @change="handleCheck(row.item)")
        template(v-slot:cell(name)="row")
          b-btn(variant="link", :to="{name: 'groups-sub', params: {groupPk: row.item.pk}}") {{row.item.name}}
        template(#cell(email)="{ value }")
          | {{ value || '-' }}
        template(#cell(phone)="{ value }")
          | {{ value || '-' }}
      b-container.mt-4.pb-4(v-if="viewMode === 'icon'")
        waterfall(
          :line-gap="140",
          :min-line-gap="140",
          :max-line-gap="220",
          :watch="groupOnPage",
          align="center")
          waterfall-slot.group-item-wrap(
            v-if="groupPk",
            move-class="item-move",
            :width="140",
            :height="120",
            :order="-1",
            key="upside")
            router-link.folder-button(:to="prevLink")
              div.folder-icon: icon(name="regular/folder-open", scale="3")
              div.title ..
          waterfall-slot.group-item-wrap(
            v-for="(group, i) in groupOnPage",
            move-class="item-move",
            :width="140",
            :height="120",
            :order="i",
            :key="group.pk")
            router-link.folder-button(:to="{name: 'groups-sub', params: {groupPk: group.pk}}")
              div.folder-icon: icon(name="regular/folder", scale="3")
              div.title {{group.name}}
              div.updated {{group.update_time | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt)}}
              router-link.setting(:to="{name: 'group-detail', params: {groupPk: group.pk}}")
                icon(name="cog", scale="1.3")
              span.remove(@click.prevent="removeGroup(group)")
                icon(name="trash", scale="1.3")
</template>

<script>
import _ from 'lodash'
import store from '@/api/store'
import { user } from '@/api/access'
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import { DeviceGroupAPI, DeviceGroupsExcelAPI } from '@/api'
import XLSX from 'xlsx'

export default {
  name: 'grouplist-component',
  components: {Waterfall, WaterfallSlot},
  props: {
    groupPk: {
      type: [String, Number],
    },
  },
  methods: {
    addGroup() {
      const companyKey = user().company_fk
      let group_fk = this.$route.params.groupPk
      let root_group_fk = null
      let group = null
      if (group_fk) {
        group_fk = parseInt(group_fk, 10)
        group = _.find(this.groups, {pk: group_fk})
        if (group) {
          root_group_fk = _.find(this.groups, {pk: group_fk}).root_group_fk
        } else {
          group_fk = null
        }
        if (!root_group_fk) {
          root_group_fk = group_fk
        }
      } else {
        group_fk = null
      }
      
      let params = {
        context: group_fk
            ? {title: this.$t('add-group-child'), path: 'add_child_group', args: {name: group.name}}
            : {title: this.$t('add_group'), path: 'add_root_group'},
        limit: 40,
        placeholder: 'name',
        submit: {
          size: 'sm',
          color: 'primary',
          text: 'create',
        },
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {
          let params = {
            name: data,
            flag_df_group: false,
            flag_confirm: false,
            group_fk,
            root_group_fk,
            company_fk: companyKey,
          }
          DeviceGroupAPI.post('', params)
              .then(resp => {
                if (resp.data.objects.overlap) {
                  this.$awn.alert(this.$t('duplication_group_name'))
                } else {
                  const group = resp.data.objects
                  this.groups.push(group)
                  store.update('devices', (update) => {
                    group.has_permission = true
                    update.groups = this.groups
                  })
                  this.$awn.success(this.$t('created_group'))
                }
              })
        }
      })
    },
    setParent(pk) {
      this.routes.parent = pk
    },
    stopBubble() {
    },
    removeGroup(group) {
      let params = {
        context: {path: 'confirm_delete_group'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'submit'},
        },
      }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') {
          return
        }
        DeviceGroupAPI.delete(`${group.pk}`)
            .then(() => {
              let index = _.findIndex(this.groups, v => v.pk === group.pk)
              this.groups.splice(index, 1)
              store.update('devices', ({groups}) => {
                _.remove(groups, v => v.pk === group.pk)
              })
              this.$awn.success(this.$t('deleted_group'))
            })
      })
    },
    excelAddGroups() {
      this.excelAdd = true
    },
    excelCancel() {
      this.excelAdd = false
    },
    readFile(event) {
      var input = event.target
      var reader = new FileReader()
      let excelFinalValidate = false
      let excelFinalParams = ''
      reader.onload = (e) => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, {type: 'binary'})
        wb.SheetNames.forEach(function (sheetName) {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 0,
            defval: '',
          })
          // var itemList = JSON.stringify(rowObj)
          
          // validate group data
          var firDep = {name: "", state: false}
          var secDep = {name: "", state: false}
          var inputDepth
          var params = []
          var addRow = {}
          var excelAddValidate = true
          
          for (var i = 0; i < rowObj.length; i++) {
            var emptyCell = 0
            
            for (var j = 0; j < 3; j++) {
              inputDepth = 4 //아무숫자나 넣음..0이아닌 디폴트값......
              if (rowObj[i][Object.keys(rowObj[i])[j]] !== '') {
                inputDepth = j
              }
              //첫 행에 루트그룹 없는 경우 처리
              if (i == 0 && j == 0 && inputDepth !== 0) {
                excelAddValidate = false
              }
              if (inputDepth == 0) {
                addRow.parent_group_name = ""
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                
                firDep.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                firDep.state = true
                secDep.state = false
              } else if (inputDepth == 1) {
                addRow.parent_group_name = firDep.name
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                
                secDep.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
                firDep.state = true
                secDep.state = true
              } else if (inputDepth == 2) {
                // 뎁스 하나 뛰어넘어 입력된 경우 처리
                if (firDep.state && !secDep.state) {
                  excelAddValidate = false
                }
                addRow.parent_group_name = secDep.name
                addRow.name = rowObj[i][Object.keys(rowObj[i])[inputDepth]]
              } else {
                emptyCell++
              }
            }
            if (emptyCell === 3) {
              excelAddValidate = false
            }
            params.push(addRow)
            addRow = {}
          }
          
          
          //그룹이름 중복된 경우 처리
          var inputVal = new Array()
          var overlapVal = new Array()
          var overlapChk = true
          for (var k = 0; k < params.length; k++) {
            inputVal.push(params[k].name)
          }
          for (var l = 0; l < inputVal.length; l++) {
            for (var value in overlapVal) {
              if (overlapVal[value] == inputVal[l]) {
                overlapChk = false
              }
            }
            if (overlapChk) {
              overlapVal.push(inputVal[l])
            }
          }
          if (!overlapChk) {
            excelAddValidate = false
          }
          
          
          params = JSON.stringify(params)
          excelFinalValidate = excelAddValidate
          excelFinalParams = params
        })
        //Vue Component에 저장
        this.excelAddValidate = excelFinalValidate
        this.excelAddParams = excelFinalParams
      }
      reader.readAsBinaryString(input.files[0])
    },
    onSubmit() {
      this.excelAdd = false
      if (this.excelAddValidate) {
        DeviceGroupsExcelAPI.post('', this.excelAddParams)
            .then(resp => {
              let total = resp.data.objects.total
              let failure = resp.data.objects.failure
              
              DeviceGroupAPI.get('')
                  .then(resp => {
                    const group = resp.data.objects
                    this.groups = group.reverse()
                    store.update('devices', (update) => {
                      group.has_permission = true
                      update.groups = this.groups
                    })
                    this.$awn.success(this.$t('excel_group_submit', {total, failure}))
                  })
            }).catch(e => {
          console.log(e)
        })
      } else {
        this.$awn.alert(this.$t('excel_group_fail'))
      }
    },
    items() {
      return this.groupOnPage.map(group => {
        const {manager_email, manager_name, manager_phone, ...rest} = group
        const formattedEmail = manager_email || '-';
        const formattedName = manager_name || '-';
        const formattedPhone = manager_phone || '-';
        return {...rest, manager_email: formattedEmail, manager_name: formattedName, manager_phone: formattedPhone};
      })
    },
    onRowClicked(item, index, event) {
      if (event.target.getAttribute('aria-colindex') === '1' || event.target.getAttribute('aria-colindex') === '2' || event.target.getAttribute('aria-colindex') === null) {
        event.stopPropagation();
        return
      }
      this.$router.push({
        name: 'groups-sub',
        params: {
          groupPk: item.pk,
        },
      })
    },
    handleCheck(item) {
      if (this.checkedGroup.some(v => v.pk === item.pk)) {
        const index = this.checkedGroup.findIndex(u => u.pk === item.pk);
        this.checkedGroup.splice(index, 1);
      }
      if (item._isSelected) {
        this.checkedGroup.push(item);
      }
      
      if (this.checkedGroup.length == this.groupOnPage.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
    checkedRemoteGroup() {
      if (this.checkedGroup.length === 0) {
        return this.$awn.warning(`삭제할 그룹을 선택해주세요.`)
      }
      let params = {
        title: 'LinkMeMine',
        context: {path: 'delete_group_confirm'},
        withoutInput: true,
        submit: {
          size: 'sm',
          color: 'danger',
          text: {path: 'delete'},
        },
      }
      const groupsPK = this.checkedGroup.map(e => e.pk)
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key !== 'submit') {
          return
        }
        for (const group of groupsPK) {
          DeviceGroupAPI.delete(group.toString())
              .then(() => {
                let index = _.findIndex(this.groups, v => v.pk === group)
                this.groups.splice(index, 1)
                store.update('devices', ({groups}) => {
                  _.remove(groups, v => v.pk === group)
                })
                this.$awn.success(this.$t('deleted_group'))
              })
        }
      })
    },
    onClickBack() {
      if (this.tree.length === 2) {
        return this.$router.push({name: 'groups'})
      }
      
      if (this.tree.length <= 1) {
        return
      }
      this.$router.push({
        name: 'groups-sub',
        params: {
          groupPk: this.tree[this.tree.length - 2].to.params.groupPk,
        },
      })
    },
    selectAllRows() {
      _.each(this.groupOnPage, v => {
        v._isSelected = this.allSelected
        this.handleCheck(v)
      })
      
      if (this.checkedGroup.length == this.groupOnPage.length) {
        this.isIndeterminate = false
      } else if (this.checkedGroup.length === 0) {
        this.isIndeterminate = false
      } else {
        this.isIndeterminate = true
      }
    },
  },
  computed: {
    groupOnPage() {
      let groups = this.groups
      if (this.groupPk) {
        let fk = parseInt(this.groupPk, 10)
        groups = _.filter(groups, {group_fk: fk})
      } else {
        groups = _.filter(groups, {group_fk: null})
      }
      return groups.map(group => {
        const {manager_email, manager_name, manager_phone, ...rest} = group
        const formattedEmail = manager_email || '-';
        const formattedName = manager_name || '-';
        const formattedPhone = manager_phone || '-';
        const isSelected = this.checkedGroup.some(item => item.pk === group.pk);
        return {
          ...rest, manager_email: formattedEmail, manager_name: formattedName, manager_phone: formattedPhone,
          _isSelected: isSelected,
        };
      })
    },
    tree() {
      let tree = []
      if (!this.groups.length) {
        return []
      }
      const addTreeItem = (pk) => {
        let current = _.find(this.groups, {pk})
        if (!current) {
          return
        }
        tree.unshift({
          text: current.name,
          to: {name: 'groups-sub', params: {groupPk: pk}},
        })
        if (current.group_fk) {
          addTreeItem(current.group_fk)
        }
      }
      if (this.groupPk) {
        addTreeItem(parseInt(this.groupPk, 10))
      }
      tree.unshift({
        text: 'ROOT',
        to: {name: 'groups'},
      })
      tree[0].text = this.$t('group') + this.$t('manage')
      return tree
    },
    prevLink() {
      if (this.groupPk) {
        let current = _.find(this.groups, {pk: parseInt(this.groupPk, 10)})
        if (current && current.group_fk) {
          return {name: 'groups-sub', params: {groupPk: current.group_fk}}
        }
        return {name: 'groups'}
      } else {
        return {name: 'groups'}
      }
    },
  },
  created() {
    let stored = store.get('devices')
    if (stored) {
      this.groups = stored.groups
    }
    let langStore = store.get('lang')
    this.lang = langStore
  },
  data() {
    return {
      groups: [],
      viewMode: 'list',
      excelAdd: false,
      excelAddValidate: true,
      excelAddParams: '',
      checkedGroup: [],
      allSelected: false,
      isIndeterminate: false,
      Form: `${this.AppState.Path.download}/form`,
      lang: '',
      fields: [
        {key: 'detail', label: '', sortable: false},
        {key: 'check', label: '', sortable: false, thStyle: { minWidth: "120px" }},
        {key: 'name', label: this.$t('group') + this.$t('name'), sortable: false, thStyle: { minWidth: "120px" }},
        {key: 'manager_name', label: this.$t('manager-id'), sortable: false, thStyle: { minWidth: "120px" }},
        {key: 'manager_email', label: this.$t('Email'), sortable: false, thStyle: { minWidth: "120px" }},
        {key: 'manager_phone', label: this.$t('phone'), sortable: false, thStyle: { minWidth: "120px" }},
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  background-color: transparent;
  margin: 0;
  padding: 0;
  color: black !important;
  font-size: 1.2rem;
  font-weight: 500;
  
  .breadcrumb-item.active {
    color: black !important;
  }
}

.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 0 0 0;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}


.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary.active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
  
  > svg {
    color: black;
  }
}

.delete-btn {
  background-color: #EC7211 !important;
  color: #FFFFFF !important;
  border: 1px solid #E96700 !important;
  font-weight: 400;
  
  &:hover {
    background-color: #E96700 !important;
    color: #FFFFFF !important;
    border: 1px solid #E96700 !important;
    font-weight: 400;
  }
}

::v-deep .b-table {
  th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  
  th:nth-child(1), th:nth-child(2) {
    width: 1rem;
  }
  
  td {
    padding: 0 0 0 1rem;
    vertical-align: middle;
    color: #6F6F6F;
    font-weight: 400;
  }
  
  th:nth-child(3), th:nth-child(4), th:nth-child(5) {
    position: relative;
    padding-right: 0;
    width: 13%;
  }
}

.folder-button, .fa-icon {
  color: #ababab;
  font-size: 14px;
}

.btn-link {
  padding: 0.41rem 0.75rem 0.41rem 0;
  font-size: 14px;
}

.tutorial-link {
  position: relative;
  padding: 0.25rem 0.7rem;
  top: 0.21rem;
  font-size: 0.75rem;
}

.util-group {
  justify-content: end !important;
}
</style>